import { apiClient } from '@/api/client'
import type { ApiSuccessResponse } from '@/types/api'

export type ApplicationDocumentType = 'offer_letter' | 'joining_letter'

export interface ApplicationDocument {
  id: number
  documentType: ApplicationDocumentType
  originalName: string
  fileSize: number | null
  uploadedAt: string
}

export const applicationDocumentsApi = {
  list: async (applicationId: number): Promise<ApplicationDocument[]> => {
    const { data } = await apiClient.get<ApiSuccessResponse<ApplicationDocument[]>>(
      `/recruiter/applications/${applicationId}/documents`,
    )
    return data.data
  },

  upload: async (applicationId: number, documentType: ApplicationDocumentType, file: File): Promise<ApplicationDocument> => {
    const form = new FormData()
    form.append('document_type', documentType)
    form.append('file', file)
    const { data } = await apiClient.post<ApiSuccessResponse<ApplicationDocument>>(
      `/recruiter/applications/${applicationId}/documents`,
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    return data.data
  },

  download: async (applicationId: number, documentId: number): Promise<string> => {
    const { data } = await apiClient.get<ApiSuccessResponse<{ downloadUrl: string }>>(
      `/recruiter/applications/${applicationId}/documents/${documentId}/download`,
    )
    return data.data.downloadUrl
  },

  delete: async (applicationId: number, documentId: number): Promise<void> => {
    await apiClient.delete(`/recruiter/applications/${applicationId}/documents/${documentId}`)
  },
}
